import { render } from "./CakeAdditionalInfo.vue?vue&type=template&id=bbbeee04"
const script = {}

import "./CakeAdditionalInfo.vue?vue&type=style&index=0&id=bbbeee04&scopped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__